import type { InputManager } from './input-manager';
import type { Direction } from '../game/state';
export class GamepadInput {
  private direction:Direction|null=null;
  private start=false;
  constructor(private input:InputManager,private onStart:()=>void){}
  poll():void{
    const pad=navigator.getGamepads?.().find(p=>p?.connected);
    const buttons=pad?.buttons;
    const x=pad?.axes[0]||0,y=pad?.axes[1]||0;
    const next=buttons?.[12]?.pressed?'up':buttons?.[13]?.pressed?'down':buttons?.[14]?.pressed?'left':buttons?.[15]?.pressed?'right':
      Math.abs(x)>0.55&&Math.abs(x)>Math.abs(y)?x>0?'right':'left':Math.abs(y)>0.55?y>0?'down':'up':null;
    if(next!==this.direction){this.input.release('gamepad');if(next)this.input.press('gamepad',next);this.direction=next;}
    const start=!!buttons?.[9]?.pressed;if(start&&!this.start)this.onStart();this.start=start;
  }
  clear():void{this.direction=null;this.start=false;this.input.release('gamepad');}
}
